<button
  *ngIf="state as s"
  mat-icon-button
  type="button"
  class="barid-indicator"
  data-testid="barid-connectivity-indicator"
  [ngClass]="'barid-indicator--' + s.level"
  [matTooltip]="s.label"
  [attr.aria-label]="s.label"
  (click)="open()">
  <mat-icon>{{ s.icon }}</mat-icon>
</button>
